import React from "react";
import "./mobwinners.css";
import constants from "../../utilities/constants.json";
import UserFaceAlt from "../../assets/img/avatar-face.jpg";
import AllTimeWinners from "./AllTimeWinners";
import useWinners from "../../hooks/useWinners";
import { useNavigate } from "react-router-dom";

const imageUrl = constants.profile_image;

// Simple, low-emphasis card. `variant` controls which style modifier is applied.
// Winner objects now carry name/image directly (no nested `.user`).
const WinnerCard = ({ winner, variant }) => {
  const navigate = useNavigate();
  const name = winner?.name;
  const image = winner?.image ? imageUrl + winner.image : UserFaceAlt;
  const isLoggedIn = !!localStorage.webKey;

  const goToProfile = () => {
    if (!isLoggedIn) return;
    navigate("/mobile-user-profile", {
      state: { rank: null, user_id: winner?.user_id?.$oid },
    });
  };

  return (
    <div
      className={`winnerCard winnerCard--${variant}`}
      style={isLoggedIn ? { cursor: "pointer" } : undefined}
      onClick={goToProfile}
    >
      <div className="winnerCard-avatar">
        <div className="winnerCard-avatar-ring">
          <img src={image} alt={name} onError={(e) => (e.target.src = UserFaceAlt)} />
        </div>
      </div>
      <p className="winnerCard-name">{name}</p>
    </div>
  );
};

const CategoryWinners = () => {
  const { winners } = useWinners();

  const finalWinners = winners?.final_winners || [];
  const bonusQuestions = winners?.general_question_winners || [];
  const finalMatchDay = winners?.daily_winners?.final || [];
  const semiFinals = winners?.daily_winners?.semi || [];
  const quarterFinals = winners?.daily_winners?.quarter || [];

  const getKey = (w, index) => w?.user_id?.$oid || `winner-${index}`;

  return (
    <div className="categoryWinners">
      <AllTimeWinners allTimeWinners={finalWinners} />

      {bonusQuestions.length > 0 && (
        <div className="categoryWinners-section categoryWinners-section--bonus">
          <h2 className="categoryWinners-sectionTitle">
            <span className="categoryWinners-sectionTitle-line categoryWinners-sectionTitle-line--left" />
            <span>Bonus Questions</span>
            <span className="categoryWinners-sectionTitle-line categoryWinners-sectionTitle-line--right" />
          </h2>
          <div className="categoryWinners-grid categoryWinners-grid--three">
            {bonusQuestions.map((w, i) => (
              <WinnerCard key={getKey(w, i)} winner={w} variant="bonus" />
            ))}
          </div>
        </div>
      )}

      {finalMatchDay.length > 0 && (
        <div className="categoryWinners-section categoryWinners-section--final">
          <h2 className="categoryWinners-sectionTitle">
            <span className="categoryWinners-sectionTitle-line categoryWinners-sectionTitle-line--left" />
            <span>Final Match Day</span>
            <span className="categoryWinners-sectionTitle-line categoryWinners-sectionTitle-line--right" />
          </h2>
          <div className="categoryWinners-grid categoryWinners-grid--one">
            {finalMatchDay.map((w, i) => (
              <WinnerCard key={getKey(w, i)} winner={w} variant="final" />
            ))}
          </div>
        </div>
      )}

      {semiFinals.length > 0 && (
        <div className="categoryWinners-section categoryWinners-section--semi">
          <h2 className="categoryWinners-sectionTitle">
            <span className="categoryWinners-sectionTitle-line categoryWinners-sectionTitle-line--left" />
            <span>Semi Final Match Days</span>
            <span className="categoryWinners-sectionTitle-line categoryWinners-sectionTitle-line--right" />
          </h2>
          <div className="categoryWinners-grid categoryWinners-grid--two">
            {semiFinals.map((w, i) => (
              <WinnerCard key={getKey(w, i)} winner={w} variant="semi" />
            ))}
          </div>
        </div>
      )}

      {quarterFinals.length > 0 && (
        <div className="categoryWinners-section categoryWinners-section--quarter">
          <h2 className="categoryWinners-sectionTitle">
            <span className="categoryWinners-sectionTitle-line categoryWinners-sectionTitle-line--left" />
            <span>Quarter Final Match Days</span>
            <span className="categoryWinners-sectionTitle-line categoryWinners-sectionTitle-line--right" />
          </h2>
          <div className="categoryWinners-grid categoryWinners-grid--three">
            {quarterFinals.map((w, i) => (
              <WinnerCard key={getKey(w, i)} winner={w} variant="quarter" />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryWinners;